// extracted by mini-css-extract-plugin
export default {"text":"offlinePage_text__PWl56"};